import { Field } from '@progress/kendo-react-form';
import { FormDropDownList, FormInput } from './FormComponents';
import { nameValidator, consumableValidator } from '../../Utilities/Validators';
import { RequirementReadDto } from '../../../../Models/Requirement/RequirementReadDto';

interface RightGreaseProps {
  consumables: any[];
  requirements: RequirementReadDto[];
  requirement?: RequirementReadDto | null;
}

export const RightGrease = ({ consumables, requirements, requirement }: RightGreaseProps) => {

  return(
    <div style={{height: "450px",}} className='py-2'>
      <div className='pt-2 pb-5'>
        <Field
          key={'name'}
          id={'name'}
          name={'name'}
          label={"Requirement Name"}
          component={FormInput}
          validator={nameValidator(requirements, requirement)}
        />
      </div>
      <Field
        key={'consumable'}
        id={'consumable'}
        name={'consumable'}
        label={"Consumable"}
        component={FormDropDownList}
        data={consumables}
        textField={"name"}
        dataItemKey={"id"}
        validator={consumableValidator()}
        required={true}
      />
    </div>
  );
};